import axios from "axios";
import { authHeader } from "./auth-header";

const getAll = () => {
  return axios.get(process.env.REACT_APP_API_URL + `amenities/list/`, {
    headers: authHeader(),
    data: {},
    params: {},
  });
};
 

export default { 
  getAll
};